export default __webpack_public_path__ + "img/img_1.c9f06612.png";